module.exports = __webpack_public_path__ + "img/b0daeb5.jpg";